module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("FOREWORD")])])]), _c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }, [_c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("URING THE WINTER")]), _vm._v(" and spring of 1954, J. Robert Oppenheimer, the wartime director of the Los Alamos atomic bomb laboratory and postwar advisor to the U.S. government, appeared before an Atomic Energy Commission (AEC) security panel. The panel’s responsibility was to determine whether he was a security risk.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The panel had been convened by Lewis Strauss, chairman of the AEC. During the past several years, Strauss and Oppenheimer had significant disagreements about the role that nuclear weapons should play in American foreign and military policy. Strauss believed that these weapons were essential for the defense of the United States. He believed that the security of our country depended on building more, and more powerful, nuclear weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Oppenheimer believed that a policy of “more and bigger” nuclear weapons would inevitably diminish our security. He was convinced that it would motivate the Soviet Union to follow suit, escalate the nuclear arms race, and create a far more dangerous international environment.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("This was a reasonable debate. It was the type of dialogue that sustains our democratic culture, a point that Oppenheimer argued in print. Strauss believed that Oppenheimer’s call for a public discussion of nuclear weapons policy was an act of sabotage committed by an influential, untrustworthy, and possibly treasonous scientist.")])]), _c('p', {
    staticClass: "FMTX"
  }, [_c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }, [_vm._v("In the hysterical atmosphere of the McCarthy period, Strauss’s hostility to Oppenheimer easily morphed into a conviction that Oppenheimer’s views were inspired by communist sympathies. His left-wing associations during the 1930s gave Strauss the opportunity, as ")]), _c('a', {
    attrs: {
      "id": "pg_x"
    }
  }, [_vm._v("chairman of the AEC, to initiate the hearing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("In the Matter of J. Robert Oppenheimer")]), _vm._v(". As Priscilla McMillan brilliantly demonstrates, this move against Oppenheimer was supported by a collection of conspirators convened by Strauss. They included J. Edgar Hoover, director of the FBI; William L. Borden, the former director of the staff of the Joint Committee on Atomic Energy; the physicist Edward Teller; and others who wished to see an expanded nuclear weapons program.")])]), _c('a', {
    attrs: {
      "id": "pg_x"
    }
  }, [_c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The charges against Oppenheimer were convoluted, inconsistent, and ultimately unsupportable in any unbiased forum. Roger Robb (the AEC’s prosecuting lawyer) and Strauss came to recognize this only after the hearing was underway. As a result, desperate to “win,” both Robb and Strauss engaged in a shocking series of illegal violations of due process, all of them contrary to the AEC’s security hearing rules. An FBI tap of Oppenheimer’s lawyer’s phone arranged by Strauss, and the transmission of their confidential conversations to prosecutor Robb, is only one egregious example.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("There is no question whether Oppenheimer’s hearing was corrupted by the government’s illegal actions; the following pages make that clear. Nor is there a serious question whether those violations influenced the 2 to 1 decision that removed Oppenheimer’s security clearance. As the dissenting member of the hearing panel wrote, the judgment against Oppenheimer was, and will forever remain, “a black mark on the escutcheon of our country.”")]), _vm._v(" "), _c('p', {
    staticClass: "AUSIG"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martin J. Sherwin")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f05f049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 78
// module chunks = 0